import { render, staticRenderFns } from "./ProductCount.vue?vue&type=template&id=43542741&scoped=true&"
import script from "./ProductCount.vue?vue&type=script&lang=ts&"
export * from "./ProductCount.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCount.vue?vue&type=style&index=0&id=43542741&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43542741",
  null
  
)

export default component.exports